import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import axios from 'axios';
import Logo from '../../components/Logo';

const BASE = process.env.REACT_APP_BACKEND_URL;

export default function PublicLegalPage({ field, titleKey }) {
  const { slug } = useParams();
  const { t } = useTranslation();
  const [practice, setPractice] = useState(null);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    axios.get(`${BASE}/api/public/practices/${slug}`).then((r) => setPractice(r.data.practice)).catch(() => setNotFound(true));
  }, [slug]);

  if (notFound) return <div className="min-h-screen flex items-center justify-center">404</div>;
  if (!practice) return <div className="min-h-screen flex items-center justify-center text-text-secondary text-sm">{t('common.loading')}</div>;

  const body = practice[field] || '';

  return (
    <div className="min-h-screen bg-background flex flex-col">
      <header className="px-6 md:px-10 py-5 border-b border-border bg-white">
        <div className="max-w-2xl mx-auto"><Logo variant="dark"/></div>
      </header>
      <main className="flex-1 px-6 py-10">
        <div className="max-w-2xl mx-auto so-card p-6 md:p-8">
          <h1 className="text-2xl font-bold mb-4">{t(titleKey)}</h1>
          <p className="text-sm text-text-secondary mb-4">{practice.name}</p>
          <pre className="whitespace-pre-wrap font-sans text-sm text-text">{body || '—'}</pre>
        </div>
        <p className="max-w-2xl mx-auto mt-4 text-xs text-text-secondary">
          <Link to={`/warteliste/${slug}`} className="so-link">← {t('common.back')}</Link>
        </p>
      </main>
    </div>
  );
}
